<template>
  <textarea class="fct-textarea" style="text-align: right;" v-model="data" :rows="10"></textarea>
</template>

<script>

import chainableVModel from "../../mixins/chainableVModel";

export default {
  mixins: [chainableVModel],
  props: ['settings'],
  computed: {
    data: {
      get: function () {
        return this.settings.data.map(r => Object.values(r).join('\t')).join('\n')
      },
      set: function (data) {
        this.settings.data = data.split('\n').map(getRowObj.bind(this))
          function getRowObj(r) {
            let values = r.split('\t')
            return this.settings.colHeaders.reduce((obj, k, i) => ({...obj, [k]: values[i] }), {})
          }
      }
    }
  }
}
</script>

<style scoped>

</style>
